export class TrpTruckkArrivalDetail {
    public CH_ARRIVALNO!: string;
    public CH_ARRIVALDATE!: string;
    public CH_NO!: string;
    public CH_FLOC!: number;
    public CH_TLOC!: number;
    public CH_VEHNO!: string;
    public CH_NOT!: number;
    public CH_ADVAMT!: number;
    public CH_BALAMT!: number;
    public CH_EXTRA_CHG!: number;
    public CH_EXTRA_WEIGHT!: number;
    public CH_OTH_CHG!: number;
    public CH_BAL_PAY!: number;
    public CH_TRUCK_REMARK!: string;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE!: boolean;
}